import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { DISABLE_AUTH } from '@/lib/flags';
import { useAuth } from '@/lib/auth-context';

interface RequireAdminProps {
  children: ReactNode
}

export default function RequireAdmin({ children }: RequireAdminProps) {
  if (DISABLE_AUTH) {
    return <>{children}</>;
  }

  const location = useLocation();
  const { isAdmin, previewRole, status, error } = useAuth();
  const hasAdminAccess = isAdmin || previewRole === 'admin';

  if (status === 'checking' || status === 'idle') {
    return <div className="p-6 text-center text-cocoa/70">Checking admin access…</div>;
  }

  if (status === 'error') {
    return (
      <div className="p-6 text-center">
        <div className="mb-2 font-medium text-red-600">Couldn’t verify admin access.</div>
        <div className="text-sm text-cocoa/70">{error || 'Unknown error'}</div>
      </div>
    );
  }

  if (!hasAdminAccess) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
